import React from "react";
import { useIntl } from "react-intl";

import { RemoteOption } from "lib/build/schema";

import { Select } from "src/common/components/Select";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import {
	useLogProp,
	useMessageProps,
	useValue
} from "src/features/forms/hooks/useField";
import { CommonProps } from "src/features/forms/types";

export const RemoteSelectRenderer: React.FunctionComponent<
	CommonProps
> = directProps => {
	const isLocked = React.useContext(IsLockedContext);
	const options = useRemoteOptions();
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<Select
			{...directProps}
			disabled={isLocked}
			options={options}
			value={value}
			onChangeValue={onChangeValue}
		/>
	);
};

function useRemoteOptions(): {
	label: string;
	value: string;
	disabled: boolean;
}[] {
	const { locale } = useIntl();
	const messageProps = useMessageProps();
	const remoteOptions = useLogProp<RemoteOption[]>(
		messageProps,
		"options",
		[]
	);
	return React.useMemo(
		() =>
			remoteOptions.map(option => ({
				value: option.value,
				label: option.labels[locale],
				disabled: option.inactive
			})),
		[remoteOptions, locale]
	);
}
